<template>
    <!--
        InputArchSolo:
        recorar que para usarlo solo es necesario pasarle la op correspondiente
        ( ejemplo: familiar, personales, profesionales, etc)
        ver en dataUser.js para afiliados o en preafiliacion segun corresponda.
    -->
    <div class="my-5">
        <v-row>
            <v-col cols="6" md="6" class="d-flex justify-center">
                <v-card class="justify-center align-center elevation-5" width="119" height="75"
                    @click="handleFileImport">
                    <div style="cursor: pointer;">
                        <!--     <v-img src="@/assets/dni-frente.png" class="mr-1" style="filter: invert(85%);"></v-img> -->
                    </div>
                    <v-card-actions class="justify-center">
                        <input ref="up" class="d-none" type="file" accept=".pdf, .jpeg, .jpg" @change="onFileChanged">
                        <!--  <v-icon x-large>mdi-file-document-outline</v-icon> -->
                        <v-card-text class="ma-0 pa-0 font-weight-bold primary--text">
                            {{ this.labelChip[0] }}
                        </v-card-text>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="6" md="6" class="d-flex justify-center">
                <v-card class="justify-center align-center elevation-5" width="119" height="75"
                    @click="handleFileImport">
                    <div style="cursor: pointer;">
                        <!--    <v-img src="@/assets/dni-dorso.png" class="mr-1" style="filter: invert(85%);"></v-img> -->
                    </div>
                    <v-card-actions class="justify-center">
                        <input ref="up" class="d-none" type="file" accept=".pdf, .jpeg, .jpg" @change="onFileChanged">
                        <!--  <v-icon x-large>mdi-file-document-outline</v-icon> -->
                        <v-card-text class="ma-0 pa-0 font-weight-bold primary--text">
                            {{ this.labelChip[1] }}
                        </v-card-text>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
    },
    mounted() {
        if (this.limite == 2) {
            if (this.otros) {
                this.labelChip = ['Recibo de haberes', 'Resol. otorgamiento de jubilacion']
                this.iconChip = ['mdi-file-document-outline', 'mdi-file-document-outline']
            }
            else {
                this.labelChip = ['DNI FRONTAL', 'DNI DORSO']
                this.iconChip = ['mdi-card-account-details-outline', 'mdi-card-bulleted-outline']
            }
        } else {
            this.labelChip = ['DOCUMENTACIÓN', 'DOCUMENTACIÓN', 'DOCUMENTACIÓN']
            this.iconChip = ['mdi-file-document-outline', 'mdi-file-document-outline', 'mdi-file-document-outline']
        }
    },
    data() {
        return {
            file: '',
            files: [],
            correct: false,
            fab: false,
            overlay: false,
            bloqueado: '',


            checkbox: false,

            labelChip: [],
            iconChip: []
        }
    },
    watch: {
        files() {
            this.filesVacio()
        },
        overlay() {
            return this.tieneFiles()
        },
    },
    computed: {
        ...mapGetters('preafiliacion', ['archivos']),
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('dataUser', ['labelTipoFamiliar']),


        fildNameCorto() {
            if (this.file.name.length > 14) {
                return this.file.name.substring(0, 14) + '...'
            } else {
                return this.file.name
            }
        },

    },
    methods: {

        //  modificacion archivos de preafiliacion 
        ...mapActions('preafiliacion', ['addFilesPre', 'deleteFilesPre', 'deleteItemPre']),

        // modificacion archivos de afiliado
        ...mapActions('dataUser', ['subirArchivos', 'addFiles', 'deleteFiles', 'deleteItem']),

        // correspondientes a las notificacioness
        ...mapActions('notificaciones', ['showSnack']),

        onClearFileInput() {
            if (this.isAuthenticated) {
                this.addFiles({ file: '', op: this.op })
            } else {
                this.deleteFilesPre({ file: '', op: this.op })
            }
            this.$emit('validarArch', false)
        },
        removeFile(index) {
            this.files.splice(index, 1)
        },

        archivoPermitido(type) {
            switch (type) {
                case "image/jpg":
                case "image/jpeg":
                case "application/pdf":
                    break;
                default:
                    return false
            }
            return true
        },
        filesVacio() {
            this.disabled = (this.files.length == 0)
        },
        tieneFiles() {
            this.overlay !== (this.archivos.length == 0)
        },
        guardar() {
            if (this.files.length !== 0) {
                if (this.isAuthenticated) {
                    this.addFiles({ file: this.files, op: this.op })
                } else {
                    this.addFilesPre({ file: this.files, op: this.op })
                }
                this.overlay = true
                this.$emit('validarArch', true)
            } else {
                this.$emit('validarArch', false)
                console.log('revisar archivos')
                this.showSnack({
                    type: '400',
                    message: 'No seleccionó ningun archivo.'
                })
            }

        },
        handleFileImport() {
            // Trigger click on the FileInput
            try {
                this.$refs.up.click();
            } catch (error) {
                console.log(error)

            }
        },
        onFileChanged(e) {
            if (e.target.files[0]) {
                /*Maximum allowed size in bytes
                  5MB Example
                 Change first operand(multiplier) for your needs*/
                const maxAllowedSize = 5 * 1024 * 1024;
                const permitido = this.archivoPermitido(e.target.files[0].type)
                if ((e.target.files[0].size < maxAllowedSize) && (permitido)) {
                    //,.jpg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document
                    this.file = e.target.files[0]
                    this.files.push(e.target.files[0])
                }
                else {
                    this.showSnack({
                        type: '400',
                        message: 'archivo no permitido. Debe ser menor a 5MB y en formato .pdf, .jpg, .jpeg o .png'
                    })
                    this.file = ''
                    this.files = []
                }
            }
        },
    },
    props: ['op', 'limite', 'label']
}
</script>
<style scoped>
.error-border {
    border: 2px solid red;
}

.files-row {
    justify-content: flex-start;
}
</style>